/**
 * 统一的分页组件配置
 */

// 导入分页样式
import './PaginationStyles.css';

export const PAGINATION_CONFIG = {
  // 默认分页配置 - 完整功能
  default: {
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total: number, range: [number, number]) => 
      `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
    pageSizeOptions: ['10', '20', '50', '100'],
    size: 'small' as const,
    simple: false,
    showSizeChangerText: false, // 隐藏"条/页"文本
    locale: {
      items_per_page: '条/页',
      jump_to: '跳转',
      page: '页',
    },
  },
  
  // 简化分页配置 - 不显示快速跳转
  simple: {
    showSizeChanger: true,
    showQuickJumper: false,
    showTotal: (total: number, range: [number, number]) => 
      `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
    pageSizeOptions: ['10', '20', '50', '100'],
    size: 'small' as const,
    simple: false,
    showSizeChangerText: false, // 隐藏"条/页"文本
    locale: {
      items_per_page: '条/页',
      jump_to: '跳转',
      page: '页',
    },
  },
  
  // 最简分页配置 - 只显示总数和页码
  minimal: {
    showSizeChanger: false,
    showQuickJumper: false,
    showTotal: (total: number) => `共 ${total} 条`,
    size: 'small' as const,
    simple: false,
  },
  
  // 超简分页配置 - 只显示页码
  ultra: {
    showSizeChanger: false,
    showQuickJumper: false,
    showTotal: () => '', // 返回空字符串而不是false
    size: 'small' as const,
    simple: false,
  }
};

// 分页文本配置
export const PAGINATION_LOCALE = {
  items_per_page: '条/页',
  jump_to: '跳转',
  jump_to_confirm: '确定',
  page: '页',
  prev_page: '上一页',
  next_page: '下一页',
  prev_5: '向前5页',
  next_5: '向后5页',
  prev_3: '向前3页',
  next_3: '向后3页',
};
